import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { NumberInput } from '@hivebrite/design-system/Inputs';

import InputTitle from '../SettingsDecoration/InputTitle';

const INPUTS = [
  {
    type: 'top',
    label: __('Top'),
  },
  {
    type: 'bottom',
    label: __('Bottom'),
  },
  {
    type: 'left',
    label: __('Left'),
  },
  {
    type: 'right',
    label: __('Right'),
  },
];

const getDisplayedInputsList = (displayedInputs, availableInputs) =>
  displayedInputs.map((displayedInput) =>
    availableInputs.find((input) => displayedInput === input.type),
  );

const PaddingInput = ({ id, onChange, value, displayedInputs }) => {
  const inputs = displayedInputs
    ? getDisplayedInputsList(displayedInputs, INPUTS)
    : INPUTS;

  return (
    <PaddingsWrapper>
      {inputs.map(({ label, type }) => (
        <PaddingWrapper key={type}>
          <InputTitle id={`${id}-${type}`} label={label} boxProps={{ mr: 2 }} />
          <NumberInput
            ariaLabel={type}
            id={`${id}-${type}`}
            name={`${id}-${type}`}
            onChange={(event) => onChange({ type, value: event.target.value })}
            value={value[type]}
            variant="small"
            width={80}
          />
        </PaddingWrapper>
      ))}
    </PaddingsWrapper>
  );
};

export default PaddingInput;

const PaddingWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
}))``;

const PaddingsWrapper = styled(Box).attrs(() => ({
  display: 'grid',
}))`
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${(props) => props.theme.space[4]}px;
`;
